"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var PictureFrame_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/PictureFrame"));
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../editor/widgets/Video/utils");
var Video = styled_components_1["default"].video(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  display: block;\n"], ["\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  display: block;\n"])));
var IFrameWrapper = styled_components_1["default"](PictureFrame_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: 0 auto;\n"], ["\n  margin: 0 auto;\n"])));
var Iframe = styled_components_1["default"].iframe(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var C = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    if (data.public_url || data.uri) {
        var src = '';
        if (data.public_url) {
            src = data.public_url;
        }
        else {
            src = "https://mediamanager.sportnet.online/media/" + data.uri;
        }
        return React.createElement(Video, { preload: "all", controls: true, src: src });
    }
    if (data.url) {
        var url = (function () {
            var embedUrl = utils_1.getYoutubeEmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            embedUrl = utils_1.getSportnetVideoEmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            if (utils_1.isLivestreamEmbedUrl(data.url)) {
                return data.url;
            }
            embedUrl = utils_1.getVimeoEmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            embedUrl = utils_1.getDalilymotionEmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            embedUrl = utils_1.getTa3EmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            embedUrl = utils_1.getIdnesEmbedUrl(data.url);
            if (embedUrl) {
                return embedUrl;
            }
            return '';
        })();
        if (url) {
            return (React.createElement(IFrameWrapper, { width: 16, height: 9 },
                React.createElement(Iframe, { src: url, frameBorder: "0", allowFullScreen: true })));
        }
        if (renderEmpty) {
            return React.createElement(React.Fragment, null, renderEmpty('video'));
        }
        return null;
    }
    if (renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('video'));
    }
    return null;
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3;
